import moment from 'moment'
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { AloCity } from '@/models/alo/AloCity'
import { AloAddress } from '@/models/alo/AloAddress'
import { concat } from '@/utils/string'



export const formatAddress = (value: AloAddress,separator:string="<br/>") => {  
  let add = ''
  if(value) {
    add = concat(add,value.adrIndoorInfos)
    let ligne2 = ''
    if(value.adrNumberWay && value.adrNumberWay != 0) ligne2 = concat(ligne2,value.adrNumberWay.toString(),separator)
    ligne2 = concat(ligne2,value.adrOutsideInfos,' ')
    add = concat(add,ligne2,separator)
    add = concat(add,value.adrPostBox,separator)
    let ligne4 = concat(value.adrPostalCode,value.libelle,' ')
    add = concat(add,ligne4,separator)
  }
  return add  
  
}

Vue.filter('formatAddress',formatAddress)
